import { Img } from "../components";
import SocialButtons from "./SocialButtons";
import { Link } from "react-router-dom";

const colHeadStyle = {
    fontFamily: "Manrope, sans-serif",
    fontSize: "11px",
    fontWeight: 700,
    color: "rgba(255,255,255,0.3)",
    letterSpacing: "0.1em",
    textTransform: "uppercase",
    marginBottom: 16,
};

const linkStyle = {
    fontFamily: "Manrope, sans-serif",
    fontSize: "13px",
    color: "rgba(255,255,255,0.5)",
    textDecoration: "none",
    display: "block",
    marginBottom: 10,
    transition: "color 0.15s",
};

export default function FooterSection() {
    return (
        <footer
            style={{
                background: "#000",
                borderTop: "1px solid rgba(255,255,255,0.07)",
                padding: "72px 48px 40px",
            }}
            className="md:px-5 md:pt-12"
        >
            <div
                style={{
                    maxWidth: 1280,
                    margin: "0 auto",
                    display: "grid",
                    gridTemplateColumns: "1.6fr 1fr 1fr 1fr",
                    gap: "40px 32px",
                    marginBottom: 56,
                }}
                className="footer-grid"
            >
                {/* Brand column */}
                <div>
                    <div style={{ display: "flex", alignItems: "center", gap: 8, marginBottom: 16 }}>
                        <Img src="images/img_television.svg" alt="logo icon" className="h-[22px]" />
                        <Img src="images/img_aihumanity.png" alt="AIHumanity" width="80" height="14" />
                    </div>
                    <p style={{
                        fontFamily: "Manrope, sans-serif",
                        fontSize: "13px",
                        color: "rgba(255,255,255,0.4)",
                        lineHeight: 1.7,
                        maxWidth: 260,
                        marginBottom: 24,
                    }}>
                        The relationship layer for next-generation AI — turning intelligence into adaptive, persistent interaction.
                    </p>
                    <SocialButtons />
                </div>

                {/* Industries column (market-vertical anchors on the home page) */}
                <div>
                    <p style={colHeadStyle}>Industries</p>
                    {[
                        { label: "Gaming & Virtual Worlds", anchor: "gaming" },
                        { label: "Companions & Assistants", anchor: "companions" },
                        { label: "Humanoid Robotics", anchor: "robotics" },
                    ].map(({ label, anchor }) => (
                        <a
                            key={anchor}
                            href={`/#${anchor}`}
                            style={linkStyle}
                            onMouseEnter={e => e.currentTarget.style.color = "rgba(255,255,255,0.85)"}
                            onMouseLeave={e => e.currentTarget.style.color = "rgba(255,255,255,0.5)"}
                        >
                            {label}
                        </a>
                    ))}
                </div>

                {/* SDK column */}
                <div>
                    <p style={colHeadStyle}>SDK & Platform</p>
                    {[
                        { label: "Emotion SDK", href: "https://developer.aihumanity.io", external: true },
                        { label: "VoicePlay", href: "https://voiceplay.aihumanity.io", external: true },
                        { label: "AI Perception", href: "/perception", external: false },
                    ].map(({ label, href, external }) => (
                        external ? (
                            <a
                                key={href}
                                href={href}
                                target="_blank"
                                rel="noopener noreferrer"
                                style={linkStyle}
                                onMouseEnter={e => e.currentTarget.style.color = "rgba(255,255,255,0.85)"}
                                onMouseLeave={e => e.currentTarget.style.color = "rgba(255,255,255,0.5)"}
                            >
                                {label}
                            </a>
                        ) : (
                            <Link
                                key={href}
                                to={href}
                                style={linkStyle}
                                onMouseEnter={e => e.currentTarget.style.color = "rgba(255,255,255,0.85)"}
                                onMouseLeave={e => e.currentTarget.style.color = "rgba(255,255,255,0.5)"}
                            >
                                {label}
                            </Link>
                        )
                    ))}
                </div>

                {/* Company column */}
                <div>
                    <p style={colHeadStyle}>Company</p>
                    <Link
                        to="/demo"
                        style={linkStyle}
                        onMouseEnter={e => e.currentTarget.style.color = "rgba(255,255,255,0.85)"}
                        onMouseLeave={e => e.currentTarget.style.color = "rgba(255,255,255,0.5)"}
                    >
                        Product Demo
                    </Link>
                    <Link
                        to="/benchmarks"
                        style={linkStyle}
                        onMouseEnter={e => e.currentTarget.style.color = "rgba(255,255,255,0.85)"}
                        onMouseLeave={e => e.currentTarget.style.color = "rgba(255,255,255,0.5)"}
                    >
                        Benchmarks
                    </Link>
                    <Link
                        to="/blog"
                        style={linkStyle}
                        onMouseEnter={e => e.currentTarget.style.color = "rgba(255,255,255,0.85)"}
                        onMouseLeave={e => e.currentTarget.style.color = "rgba(255,255,255,0.5)"}
                    >
                        Blog
                    </Link>
                    <a
                        href="mailto:david@aihumanity.io"
                        style={linkStyle}
                        onMouseEnter={e => e.currentTarget.style.color = "rgba(255,255,255,0.85)"}
                        onMouseLeave={e => e.currentTarget.style.color = "rgba(255,255,255,0.5)"}
                    >
                        Contact
                    </a>
                    <p style={{
                        fontFamily: "Manrope, sans-serif",
                        fontSize: "12px",
                        color: "rgba(255,255,255,0.25)",
                        marginTop: 4,
                        lineHeight: 1.5,
                    }}>
                        San Francisco Bay Area, CA
                    </p>
                </div>
            </div>

            {/* Bottom bar */}
            <div
                style={{
                    maxWidth: 1280,
                    margin: "0 auto",
                    borderTop: "1px solid rgba(255,255,255,0.06)",
                    paddingTop: 24,
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "space-between",
                }}
            >
                <p style={{
                    fontFamily: "Manrope, sans-serif",
                    fontSize: "12px",
                    color: "rgba(255,255,255,0.22)",
                }}>
                    © {new Date().getFullYear()} AIHumanity. All rights reserved.
                </p>
                <p style={{
                    fontFamily: "Manrope, sans-serif",
                    fontSize: "12px",
                    color: "rgba(255,255,255,0.22)",
                }}>
                    The Relationship Layer for AI
                </p>
            </div>
        </footer>
    );
}
